<template>
	<div class="">
		<div class="store mb20">
			<div  class="store_head  ">
				<img class="store_img" src="https://mp.mocols.com/common/admin/admin_banner.jpg" mode="aspectFill"></img>
				<div class="store_flex ">
					<div class="store_name">
						<span class="store_name_name">门店名称</span>
					</div>
					<div class="store_data flex_c_s">
						<div class="store_data_left">起送¥99 配送¥99 月售99+</div>
						<div class="store_data_right">99km</div>
					</div>
					<div class="store_tags">
						<div  class="store_tags_item">店铺回头客超99+</div>
						<div  class="store_tags_item"  >99+人好评</div>
						<!-- <div v-for="(ite,ind) in item.goods_label" :key="ind" class="store_tags_item">{{ite}}</div> -->
					</div>
					<div scroll-x="true" class="store_quan">
						<div  class="store_quan_item flex_c">
							<span>优惠券</span>
							<img class="store_quan_icon" src="https://mp.mocols.com/common/weishop/life/quan.png" mode="widthFix"></img>
						</div>
					</div>
				</div>
			</div>
			<div v-if="params.auto.show_goods==1" scroll-x="true" class="good">
				<div  class="good_item ellipsis">
					<img class="good_item_img"  src="https://mp.mocols.com/common/admin/admin_banner.jpg" mode="aspectFill"></img>
					<div class="good_item_name ellipsis">商品名称</div>
					<div class="good_item_price">
						<div class="good_item_type">￥</div>
						<div class="good_item_num">99</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'UTag',
	  components: {
	  },
	  props: {
	    // 标签文字
	    params: {
			type:Object
		},
	  },
	  data () {
	    return {}
	  }
	}
</script>

<style lang="scss" scoped>
	.store{
		margin-left: auto;
		margin-right: auto;
		background-color: #fff;
		border-radius: 5px;
		padding:12px 8px;
		&_head{
			display: flex;
			align-items: flex-start;
			justify-content: space-between;
		}
		&_img{
			width: 60px;
			height: 60px;
			display: block;
			margin-right: 8px;
			border-radius: 2px;
		}
		&_flex{
			flex:1
		}
		&_name{
			&_tag{
				color: #fff;
				padding-left: 3px;
				padding-right: 3px;
				height: 20px;
				line-height: 20px;
				text-align: center;
				color: #fff;
				font-size: 12px;
				background: #FF6400;
				border-radius: 2px;
				margin-right: 4px;
			}
			&_name{
				color: #1F2123;
				font-size: 14px;
				font-weight: bold;
			}
		}
		&_data{
			padding-top: 10px;
			margin-bottom: 10px;
			&_left{
				color: #5A595E;
				font-size: 12px;
			}
			&_right{
				color: #5A595E;
				font-size: 12px;
			}
		}
		&_tags{
			white-space: nowrap;
			margin-bottom: 4px;
			&_item{
				display: inline-block;
				height: 16px;
				background: #FAF5E9;
				border-radius: 2px;
				line-height: 16px;
				padding: 0 6px;
				color: #896221;
				font-size: 10px;
				font-weight: bold;
				margin-right: 4px;
			}
		}
		&_quan{
			white-space: nowrap;
			&_item{
				display: inline-flex;
				height: 16px;
				margin-right: 4px;
				line-height: 16px;
				background: #FFFFF5;
				border-radius: 4px;
				border: 1px solid #FE6531;
				color: #FE6531;
				font-size: 12px;
				font-weight: bold;
				span{
					padding-left: 2px;
				}
			}
			&_icon{
				width: 24px;
				height: 16px;
				display: block;
			}
		}
	}
	
	.good{
		white-space: nowrap;
		margin-top: 8px;
		&_item{
			display: inline-block;
			margin-right: 8px;
			&_img{
				height: 65px;
				width: 65px;
				display: block;
				border-radius: 7px;
				margin-bottom: 9px;
			}
			&_name{
				color: #1F2123;
				font-size: 11px;
				width: 65px;
			}
			&_price{
				display: flex;
				align-items: flex-end;
				margin-top: 7px;
			}
			&_type{
				font-size: 10px;
				color: #FE4925;
				font-weight: bold;
				line-height: 10px;
			}
			&_num{
				font-size: 13px;
				color: #FE4925;
				font-weight: bold;
				line-height: 13px;
			}
		}
	}
</style>